import {Injectable} from '@angular/core';

import {HttpClient} from '@angular/common/http';

import {BillingDetailsModel} from '../model/billing-details.model';
import {environment} from '@env/environment';
import {Observable} from 'rxjs';
import {ConsoleContextService} from "@security/console-context.service";
import {BaseService} from "@ui-kit/framework/common/base.service";


@Injectable({
  providedIn: 'root'
})
export class BillingDetailsService extends BaseService {

  baseUrl = environment.apiDistrictsHost;

  constructor(private http: HttpClient, private context: ConsoleContextService) {
    super();
  }

  updateBillingDetails(request: BillingDetailsModel): Observable<BillingDetailsModel> {
    const offeringUuid = this.context.getCurrentOfferingId();
    const uri = this.baseUrl + `/console/districts/${offeringUuid}/billing`;
    return this.http.post<BillingDetailsModel>(uri, request);
  }

  getBillingDetailsForRetailer(): Observable<BillingDetailsModel> {
    const offeringUuid = this.context.getCurrentOfferingId();
    const uri = this.baseUrl + `/console/districts/${offeringUuid}/billing`;
    return this.http.get<BillingDetailsModel>(uri);
  }
}
